import type { OpenAPI } from "simplydo/interfaces";

export type IdeaTemplateField = NonNullable<
  NonNullable<OpenAPI.Schemas["IdeaTemplate"]["body"]>[number]["fields"]
>[number];

export type AssessmentFieldOptions = {
  availableScore?: number;
  notes?: string;
  weighting?: number;
};

export type IdeaFileValue = { name: string; value: string; _id?: string };

export type SliderFieldValue = { value?: number; notes?: string };

export type TableFieldValue = {
  data?: Array<Record<string, { value?: string }>>;
};

export type CompanyReportFieldValue = {
  _id?: string;
  report?: string;
  reportUrl?: string;
  [key: string]: unknown;
};

export type IdeaFieldValue = unknown;

export type UpdateIdeaField = (
  value: unknown,
  path: string[],
  replace?: boolean,
) => void;

export type FieldProps = {
  field: IdeaTemplateField;
  ideaId: string;
  challengeId: string;
  fieldValue: unknown;
  isEditing?: boolean;
  updateIdea: UpdateIdeaField;
  assessmentIsClosed?: boolean;
  isAssessment?: boolean;
};

export const getStringFieldOptions = (
  options: IdeaTemplateField["options"],
): string[] => (Array.isArray(options) ? options : []);

export const getAssessmentFieldOptions = (
  options: IdeaTemplateField["options"],
): AssessmentFieldOptions => (Array.isArray(options) ? {} : (options ?? {}));
